import React from 'react';
import classNames from 'classnames';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

type OldMenuDrawerClasses = {
  drawerPaper: string;
  drawerPaperClose: string;
  menuContent: string;
  toolbarIcon: string;
};

type OldMenuDrawerProps = {
  children: React.ReactNode;
  classes: OldMenuDrawerClasses;
  isAuthenticated: boolean;
  menuOpen: boolean;
  onDrawerClose: () => void;
  onSwitchToNewMenu: () => void;
  t: (key: string) => string;
};

export function OldMenuDrawer({
  children,
  classes,
  isAuthenticated,
  menuOpen,
  onDrawerClose,
  onSwitchToNewMenu,
  t,
}: OldMenuDrawerProps): JSX.Element | null {
  if (!isAuthenticated) {
    return null;
  }

  return (
    <Drawer
      variant="permanent"
      classes={{
        paper: classNames(classes.drawerPaper, !menuOpen && classes.drawerPaperClose),
      }}
      open={menuOpen}
    >
      <div className="flex justify-between items-center">
        <span className="cursor-pointer pl-5" onClick={onSwitchToNewMenu}>
          {t('switch_to_new_menu_label')}
        </span>
        <div className={classes.toolbarIcon}>
          <IconButton onClick={onDrawerClose} size="large">
            <ChevronLeftIcon />
          </IconButton>
        </div>
      </div>
      <div className={classes.menuContent}>{children}</div>
    </Drawer>
  );
}
